import React from 'react';
import { Button, Modal, Typography } from 'antd';

const { Text } = Typography;

const OpenShiftClaimDialog = ({
  open,
  selectedBookedItem,
  starttime,
  endtime,
  onClaim,
  onCancel,
}) => {
  return (
    <Modal open={open} onCancel={onCancel} footer={null} title="Claim open shift">
      <div style={{ display: 'grid', gap: 12 }}>
        <Text>You can claim this open shift.</Text>
        <Text>
          {selectedBookedItem?.date || '-'} {starttime || selectedBookedItem?.starttime || ''}
          {starttime || selectedBookedItem?.starttime ? ' - ' : ''}
          {endtime || selectedBookedItem?.endtime || ''}
        </Text>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" onClick={onClaim}>Claim</Button>
        </div>
      </div>
    </Modal>
  );
};

export default OpenShiftClaimDialog;